module.exports = __webpack_public_path__ + "img/img_nav_recommend-w.f51f61e8.svg";